import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { CancelacionBien } from "./cancelacion.component";
import { CancelacionService } from "./cancelacion.service";
import { UtilService } from "../../../components/common/utils/util.service"
import {DataTableModule} from "angular2-datatable";
import {FileUploadModule} from "ng2-file-upload/ng2-file-upload";

@NgModule({
    declarations: [CancelacionBien],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        FileUploadModule],
    providers: [CancelacionService, UtilService],
    exports: [CancelacionBien]
})

export class CancelacionModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/cancelaciones/cancelacion.module.ts